import React, { useEffect, useState } from "react";
import { Card, Row, Col, CardBody } from "reactstrap";

const LeftSummaryWidget = ({ code_siep, h100 = true }) => {
  const [temperatureData, setTemperatureData] = useState(null);
  const [salinityData, setSalinityData] = useState(null);
  const [oxygenData, setOxygenData] = useState(null);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    const mockTemperatureData = {
      value: 12.5,
      unit: "°C",
      title: "Temperatura",
      difference: "+0.3",
      positive: true,
    };
    const mockSalinityData = {
      value: 33.2,
      unit: "psu",
      title: "Salinidad",
      difference: "-0.1",
      positive: false,
    };
    const mockOxygenData = {
      value: 68,
      unit: "%",
      title: "Oxígeno Disuelto",
      difference: "+2.1",
      positive: true,
    };

    setTemperatureData(mockTemperatureData);
    setSalinityData(mockSalinityData);
    setOxygenData(mockOxygenData);
  }, [code_siep]);

  const MetricCard = ({ data }) => (
    <Col xs={4}>
      <Card className="rounded-4">
        <CardBody
          className="d-flex flex-column p-3"
          style={{ minHeight: "110px" }}
        >
          <span className="text-muted fw-semibold fs-12">{data?.title}</span>

          <div className="d-flex gap-2 align-items-end mt-1">
            <h3 className="m-0 fw-bold text-dark fs-22">
              {data?.value}
              <span className="fs-16 ms-1">{data?.unit}</span>
            </h3>
            {data?.positive ? (
              <i className="ri-arrow-right-up-line fs-16" style={{ color: '#3EA58A' }}></i>) : (
              <i className="ri-arrow-right-down-line fs-16" style={{ color: '#E25D37' }}></i>)}
          </div>
          <span
            className="fw-bold fs-12"
            style={{ color: data?.positive ? '#3EA58A' : '#E25D37' }}
          >
            {data?.difference}
          </span>
          <span className="text-muted fs-10 mt-1">
            vs. semana anterior
          </span>
        </CardBody>
      </Card>
    </Col>
  );

  return (
    <Row className="g-2">
      <MetricCard data={temperatureData} textClass="text-primary" />
      <MetricCard data={oxygenData} textClass="text-success" />
      <MetricCard data={salinityData} textClass="text-info" />
    </Row>
  );
};

export default LeftSummaryWidget;
